import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/699ad1e4f782d5001402abd4/pc_cargo_website/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/699ad1e4f782d5001402abd4/pc_cargo_website/src/app/comparison/components/ComparisonPageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/699ad1e4f782d5001402abd4/pc_cargo_website/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/699ad1e4f782d5001402abd4/pc_cargo_website/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/699ad1e4f782d5001402abd4/pc_cargo_website/src/components/ui/AppLogo.tsx");
